import React, { useState, useEffect, useContext, useRef } from "react";
import { Modal, Button } from 'react-bootstrap';
import { DateTime } from "luxon";
import Swal from 'sweetalert2';
import axios from "axios";
import {FormattedMessage, useIntl } from 'react-intl';
import { FirebaseContext } from "../../contexts/firebase.context";
import { RouteContext } from "../../contexts/route.context";
import firebase from "firebase/app";
import 'firebase/database'; // If using Firebase database
import moment from "moment";
import chatCamera from '../../assets/images/chat_camera_2.svg';
import chatFile from '../../assets/images/chat_attachment_2.svg';
import chatLocation from '../../assets/images/chat_location_2.svg';
import chatMicrophone from '../../assets/images/chat_microphone_2.svg';
import MapContainer from "./settings/mapcontainer";
import defaultAvatar from '../../assets/images/profpic.svg';


const ItemChat = ({message,attachment,onSelectImage, onTapFile, usertype}) => {
  const [theUrl, setTheUrl] = useState()
  const [urlSupported, setUrlSupported] = useState()

  useEffect(()=>{
    setUrlSupported(checkUrlValid(message))
  },[message])

  const checkUrlValid = (url) => {
    let fccUrl;
    try{
      fccUrl = new URL(url);
      // return true;
    }
    catch(e){
      return false
    }
    if(/https?/.test(fccUrl)){
      setTheUrl(getProtocolHostName(message))
    }
    return /https?/.test(fccUrl);
  }

  function getHostName(s){
    let url;
    try {
      url = new URL(s);
    } catch (e) { return false; }
    return url.host;
  }

  function getProtocolHostName(s) {
    let url;
    try {
      url = new URL(s);
    } catch (e) { return false; }
    return url.hostname;
  }

  return(
  <div>
    <div className={`${usertype === 'sender' && urlSupported ? "sender-msg-div-content-supported" : usertype === 'sender' ? "sender-msg-div-content" : usertype === 'receiver' && urlSupported ? "receiver-msg-div-content-supported" : "receiver-msg-div-content"}`}>
      {urlSupported
      ?
      <div>
        <div onClick={()=>{
          window.open(message)
        }} className="url-text">
          {message}
        </div>
      </div>
      :
      attachment ?
      <div
      className="url-text"
      onClick={()=>{
        window.open(attachment)
      }}
      >
        {attachment.replace("https://admin.renter.net/storage/", "")}
      </div>
      :
      <div>
        {message}
      </div>
      }
    </div> 
    {
      urlSupported &&
      <div className={`url-protocol ${usertype === 'sender' ? "sender-url" : "receiver-url"}`}>
        {getHostName(message)}
      </div>
    }
    
  </div>
   
  )
}

const AudioFile = ({audio, index}) => {
  let myAudio = document.getElementById(`audio${index}`);
  const [myTimer, setMyTimer] = useState(0)
  const [isPlaying, setIsPlaying] = useState(false)
  const intervalRef = useRef(null);

  useEffect(()=>{
    // console.log(`${('0'+Math.floor((myTimer % 3600) / 60))?.slice(-2)}:${('0'+(myTimer % 60)).slice(-2)?.toString().replaceAll(" ", "")}`, audio?.voice_duration?.toString().replaceAll(" ", ""))
    // console.log(`${('0'+Math.floor((myTimer % 3600) / 60)).slice(-2)} : ${('0'+(myTimer % 60)).slice(-2).toString()}`, audio.voice_duration.toString())
    if(`${('0'+Math.floor((myTimer % 3600) / 60))?.slice(-2)}:${('0'+(myTimer % 60)).slice(-2)?.toString().replaceAll(" ", "")}` === audio?.voice_duration?.toString().replaceAll(" ", "")){
      // console.log("YES")
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      setIsPlaying(false);
    };
  },[myTimer])

  const startTimerRecordConfirmation = () => {
    if (intervalRef.current) return;
    intervalRef.current = setInterval(() => {
        setMyTimer((prev) => {
          const next = prev + 1;
          return next;
        });
    }, 1000);
  };
  
  return(
    <div>
      {
        audio?.attachment &&
        <audio id={`audio${index}`}  src={audio.attachment}>
            {/* <source type="audio/mp3"/> */}
        </audio>
      }
      <div className="audio-player">
        <div className="audio-player-play" onClick={()=>
        {
          if(!isPlaying){
            setMyTimer(0);
            setIsPlaying(true);
            myAudio.src=audio.attachment
            myAudio.load(); 
            myAudio.play();
            startTimerRecordConfirmation();
          }
          else{
            setIsPlaying(false);
            setMyTimer(0);
            clearInterval(intervalRef.current);
            intervalRef.current = null;
            myAudio.pause();
            myAudio.currentTime = 0;
          }
          // setMyTimer(0)
        }
      }>
        <svg width="15px" height="15px" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#515151">
          <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
          <g id="SVGRepo_iconCarrier"> <path d="M1 14H3L9 8L3 2H1V14Z" fill="#515151"/> <path d="M15 2H13V14H15V2Z" fill="#515151"/> <path d="M9 2H11V14H9V2Z" fill="#515151"/> 
          </g>
        </svg>
      </div>
        <div className="audio-player-duration">
          <span>{`${myTimer > 0 ? `${('0'+Math.floor((myTimer % 3600) / 60)).slice(-2)}:${('0'+(myTimer % 60)).slice(-2).replaceAll(" ", "")}` : "00:00"}`}</span>
        </div>
      </div>
    </div>
  )
}



const ChatLease = () => {
  const intl = useIntl();
  const bottomRef = useRef(null);
  const { baseURL, apiHeaders, getMe, me, getChatList, chatList, getUserChatList,
    userChatList, getChatUserDetails, chatUserDetails, setRoomRefParams, roomRef, generalStatus, getChatRoomUserDetails } = useContext(RouteContext);
  const { database } = useContext(FirebaseContext);
  const [chatIds, setChatIds] = useState([]);
  const [listUser, setListUser] = useState([]);
  const [listUserLoader, setListUserLoader] = useState(true);
  const [chosenChat, setChosenChat] = useState();
  const [chatMsg, setChatMsg] = useState("");
  const [uploadPhotoChat, setUploadPhotoChat] = useState();
  const [chatOptionsHidden, setChatOptionsHidden] = useState(true);
  const [isSending, setIsSending] = useState(false);
  const messagesEndRef = useRef(null);
  const [showModalStart, setShowModalStart] = useState(false);
  const [mapModal, setMapModal] = useState(false)
  const [addressLatLng, setAddressLatLng] = useState();
  const [chatListModal, setChatListModal] = useState(false);
  const [chatRoomUserDetails, setChatRoomUserDetails] = useState([])

  let room_user_details = ''

  const [userDatabase, setUserDatabase] = useState(null)
  const [paramsUserDatabase, setParamsUserDatabase] = useState(null)

  
  const [imageFiles, setImageFiles] = useState(['png','jpg','jpeg', 'PNG', 'JPG', 'JPEG'])
  const [audioFiles, setAudioFiles] = useState(['wav', 'mp3', 'm4a', 'oog'])
  const [viewPhoto, setViewPhoto] = useState()

  useEffect(()=>{
    if (roomRef) {
      getChatListInfo();
      let user_email = `fb_user${me?.id}`
      let courier_email = `fb_user${chosenChat?.id}`
      // if (user_login_details?.role?.id == "3") {
      //   room_string = `room/${courier_email}_${user_email}/messages`
      // } else {
      //   room_string = `room/${user_email}_${courier_email}/messages`
      // }
      room_user_details = `${roomRef.replaceAll('/messages','')}/users/${user_email}`
      setUserDatabase(database.ref(`${room_user_details}`))
      setParamsUserDatabase(database.ref(`${roomRef.replaceAll('/messages', '')}/users/fb_user${chosenChat?.id}`))
    }
  },[roomRef])

  // const userDatabase = database.ref(`${room_user_details}`);
  // const paramsUserDatabase = database.ref(`${roomRef.replaceAll('/messages', '')}/users/fb_user${chosenChat?.id}`);
  

  useEffect(() => {
    getMe();
  }, []);

  const getChatRoomUserDetail = async (arrayIds) => {
    let result = await getChatRoomUserDetails(arrayIds)
    setChatRoomUserDetails(result.data)
    // console.log(result)
  }

  const getChatListInfo = async () => {
    let arrayIds = new Array()
    const listCheck = database.ref(`${roomRef?.replaceAll('/messages','')}/users`);
    const checkIfExists = (await listCheck.once('value')).val();
    if(checkIfExists){
      Object.keys(checkIfExists).forEach(function(key, index){
        arrayIds.push(key.replaceAll('fb_user', ''))
      })
    }
    getChatRoomUserDetail(arrayIds);
  }
  

  useEffect(() => {
    if(me) {
      // setListUserLoader(true);
      getUserChatList(me.id, me.role.id);
    }
  }, [me]);

  useEffect(() => {
    if(userChatList) {
      let arrayIds = new Array();

      userChatList.map((e) => {
        // console.log("E", e)
        arrayIds.push(parseInt(e.user_id));
      });

      const arrayIdsFil = arrayIds.filter(function (value) {
        return !Number.isNaN(value);
      });
      setChatIds(arrayIdsFil);
      
      setListUserLoader(false);
    }


  }, [userChatList]);

  useEffect(() => {
    if(chatIds.length !== 0) {
      getChatUserDetails(chatIds);
    }
    
  }, [chatIds]);

  useEffect(() => {
    // setListUserLoader(true);
    userChatListReader(userChatList, chatUserDetails)
  }, [
    userChatList, 
    chatUserDetails,
    generalStatus]);

  const userChatListReader = (ucl, cud) => {
    let listArr = new Array();
    
    // setListUserLoader(true);
    if(ucl && cud) {
      
      // let listArrStat = new Array();
      ucl.map((e)=>{
        setListUser([]);
        let userIndi = cud.data.filter((usc)=> usc.id === e.user_id);
        e.name = userIndi[0]?.name
        e.id = userIndi[0]?.id
        e.avatar = userIndi[0]?.avatar
        listArr.push(e)
      });
      

      if(generalStatus){
        // listArr = []
        listArr.map((child)=>{
          let userStat = generalStatus.filter((gen)=> gen.user_id === child.user_id)
          // console.log(generalStatus)
          // console.log(userStat)
          child.is_online = userStat[0]?.devices ? true : false
          // console.log(listArr, generalStatus)
        })
      }
      setListUser(listArr.reverse());
    }
  }

  const saveToUserChatList = async (lastMessageKey) => {
    const fb = database.ref(`users/fb_user${me.id}/fb_user${chosenChat.id}`); //check if naka storya na nimo ang user
    const checkIfExists = (await fb.once('value')).val();
    if (!checkIfExists) { //kung wala pa naka storya i-insert nimo
      fb.set({
        chat_count: 0,
        time: moment(new Date()).format('hh:mm a'),
        date: moment(new Date()).format('LL'),
        timestamp: firebase.database.ServerValue.TIMESTAMP,
        last_message:chatMsg,
        unread_messages: '[]'
      })
    } else {
      //else mag udpate ka
      const updateParamsUser = database.ref(`users/fb_user${chosenChat.id}/fb_user${me.id}`); //icheck and ka storya nimo kung naaa ba syay unread messages nimo
      const currentParamsUserData = (await updateParamsUser.once('value')).val()
      const fbcheck = database.ref(`${roomRef.replaceAll('/messages','')}/users/fb_user${chosenChat.id}`); //check if online si user sa chat room
      const userData = await (await fbcheck.once('value')).val()

      let chat_count = 0;
      let unread_messages = []
      if (userData) {
        if (userData?.is_online == false) {
          chat_count = currentParamsUserData.chat_count + 1
          if (currentParamsUserData.unread_messages) {
            unread_messages = JSON.parse(currentParamsUserData.unread_messages) //kung naay unread messages, i parse siya sa variable
            unread_messages.push(lastMessageKey) //i push nimo sa variable
          } else {
            unread_messages = [lastMessageKey] //iset na isa lang ang last message.
          }
        } else {
          chat_count = 0
        }
      }
      const updateUser = database.ref(`users/fb_user${me?.id}/fb_user${chosenChat.id}`);
 
      updateUser.update({
        time: moment(new Date()).format('hh:mm a'),
        date: moment(new Date()).format('LL'),
        timestamp: firebase.database.ServerValue.TIMESTAMP,
        last_message:chatMsg
      })
      updateParamsUser.update({
        chat_count: chat_count,
        time: moment(new Date()).format('hh:mm a'),
        date: moment(new Date()).format('LL'),
        timestamp: firebase.database.ServerValue.TIMESTAMP,
        last_message:chatMsg,
        unread_messages: JSON.stringify(unread_messages) //i stringify para ma save sa firebase
      })
    }
  }

  const notifyLessor = async (lessor_id, message) => {
    let result = await axios({
      url: baseURL,
      headers: apiHeaders,
      method: "post",
      data: {
        query: `
          mutation {
            chatNotify(input: {receiver_id: "${lessor_id}", save_notification_logs: ${true}, message: "${message}"}){
              id
              status
              message
            }
          }
        `
      }
    });
  }

  const onSendMessage = async(attachment_url) => {
    setIsSending(true)
    if(finalAudio){
      setIsSending(true)
      uploadImageToFirebaseGetUrl(chosenChat);
    }
    else if(uploadPhotoChat){
      setIsSending(true)
      uploadImageToFirebaseGetUrl(chosenChat);
    }
    else if (chatMsg?.length > 0 && !uploadPhotoChat) {
     
      notifyLessor(chosenChat.id, chatMsg)
      
      const database1 = database.ref(`${roomRef}`); //access ka sa messages
      const firstPushSnapshot = await database1.once('value'); //check kung naa na ba messages

      let result = await database1.push({ //save sa messages
        customer_id: me?.id,
        provider_id:chosenChat.id,
        sender_id: me.id,
        message: chatMsg,
        time: moment(new Date()).format('hh:mm a'),
        date: moment(new Date()).format('LL'),
        attachment: 
        // attachment_url? attachment_url : 
        '',
      })
      saveToUserChatList(result.key)
      
      if (firstPushSnapshot.val() == null) {
        userDatabase.set({
          is_online: true
        })
        paramsUserDatabase.set({
          is_online: false
        })
        //add loop diri sa mga assistant, para ma dd dd2 key sa users
      }
      setIsSending(false)
      setChatMsg('')
      setAudio(null);
      setStream(null);
      setFinalAudio(null);
      setPermission(false);
      setAudioChunks([]);
      // setInputState(false)
    }
    else{
      setIsSending(false)
    }
  }
  
  
  const onClickChat = (chat) => {
    setChosenChat(chat);
    setRoomRefParams(me.id, chat.id, "lessee")
    // getChatList();
    bottomRef.current?.scrollIntoView({behavior: 'smooth', block: 'end', inline: 'start'});
    // readChat(chat.id)
  }

  // upload image
  const hiddenFileInputPhotoChat = useRef(null);

  const hiddenFileInputFileChat = useRef(null);

  const handleClickPhotoChat = event => {
    hiddenFileInputPhotoChat.current.click();
  };

  const handleClickFileChat = event => {
    hiddenFileInputFileChat.current.click();
  };

  const handleChangeFileChat = event => {
    const fileUploaded = event.target.files[0];
    setUploadPhotoChat(fileUploaded);
    setChatMsg(fileUploaded.name);
  };

  const handleChangePhotoChat = event => {
    const fileUploaded = event.target.files[0];
    // if (fileUploaded) {
    //   var reader = new FileReader();
    //   reader.readAsDataURL(fileUploaded);
    //   reader.onloadend = function () {
    //     document.getElementById("previewimg").src = reader.result;
    //   }
    // }
    setUploadPhotoChat(fileUploaded);
    setChatMsg(fileUploaded.name);
  };

  
  // const onSelectFile = async () => {
  //   try {
  //     // setInputState(true)
  //     let result_file = await DocumentPicker.pickSingle({
  //       type: [DocumentPicker.types.allFiles],
  //     })
      
  //     if (result_file) {
  //       const file = await generateRNFile(result_file.uri,Date.now()+result_file.name,result_file.type)
  //       console.log(file)
  //       let result_upload = await uploadChatImage({
  //         imageFile: file
  //       })
  //       // onSendMessage(result_upload?.url)
  //     }
      
  //   } catch (e) {
  //     console.log('error', e)
  //   }
    
    
  // }

  // upload img to api then success return img url
const uploadImageToFirebaseGetUrl = async (chosenChat) => {
  setIsSending(true)
  const formData = new FormData();
  const query = `
    mutation($input: uploadImageChatInput!){
      uploadImageChat(input:$input){
        file_name
        url
      }
    }
  `;

  const input = {
    image: null,
  };

  const operations = JSON.stringify({ query, variables: { input } });
  formData.append("operations", operations);

  const map = {
      "0": ["variables.input.image"],
  };
  formData.append("map", JSON.stringify(map));

  const file = uploadPhotoChat? uploadPhotoChat : finalAudio ? finalAudio : null;


  formData.append("0", file);

  let result = await axios({
      url: baseURL,
      method: "post",
      headers: apiHeaders,
      data: formData
  });

  if(result.data.data) {
    
    notifyLessor(chosenChat.id, "Sent an Recording")

    let urlImg = result.data.data.uploadImageChat.url;

    const database1 = database.ref(`${roomRef}`); //access ka sa messages
    const firstPushSnapshot = await database1.once('value'); //check kung naa na ba messages
    

    let resultx = await database1.push({ //save sa messages
      customer_id: me?.id,
      provider_id:chosenChat.id,
      sender_id: me.id,
      message: chatMsg,
      time: moment(new Date()).format('hh:mm a'),
      date: moment(new Date()).format('LL'),
      attachment: urlImg ? urlImg : '',
      voice_duration: myTimer > 0 ? `${('0' + Math.floor((myTimer % 3600) / 60)).slice(-2)}  :  ${('0' + (myTimer % 60)).slice(-2)}` : ""
    })
    
    saveToUserChatList(resultx.key)

    if (firstPushSnapshot.val() == null) {
      userDatabase.set({
        is_online: true
      })
      paramsUserDatabase.set({
        is_online: false
      })
      //add loop diri sa mga assistant, para ma dd dd2 key sa users
    }
    setIsSending(false)
    setChatMsg("");
    setUploadPhotoChat();
    setAudio(null);
    setStream(null);
    setFinalAudio(null);
    setPermission(false);
    setAudioChunks([]);
    setMyTimer(0)

    // getChatList(me.id, chosenChat.id);
    bottomRef.current?.scrollIntoView({behavior: 'smooth', block: 'end', inline: 'start'});
  }
  else {

    if(result.data.errors[0].extensions.category === "validation") {
      let errorMsg = result.data.errors[0].extensions.validation;
      let errorMsgArray = new Array();
      Object.keys(errorMsg).map((key) => {
        errorMsgArray.push(errorMsg[key][0]);
      });


      Swal.fire({
        title: 'Uploading File Failed',
        text: errorMsgArray.toString(),
        icon: 'warning',
        confirmButtonColor: '#ff9035',
      }).then((e) => {
        window.location.reload();
      });
    }
    else {
      Swal.fire({
        title: 'Uploading Image Failed',
        text: result.data.errors[0].message,
        icon: 'warning',
        confirmButtonColor: '#ff9035',
      }).then((e) => {
        window.location.reload();
      });
    }

  }
}

  // if hit enter key
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      setIsSending(true)
      // if uploading chat img
      if(uploadPhotoChat) {
        uploadImageToFirebaseGetUrl(chosenChat);
      }
      else {
        onSendMessage()
      }
      setIsSending(false)
      // bottomRef.current?.scrollIntoView({behavior: 'smooth', block: 'end', inline: 'start'});
    }
  }


  const handleCloseModalStart = () => {
    setViewPhoto(null)
    setShowModalStart(false)
  };

  const handleCloseModalMap = () => {
    setMapModal(false)
  }

  const handleCloseModalChatList = () => {
    setChatListModal(false)
  }

  const onViewPhoto = (image) => {
    setViewPhoto(image)
    setShowModalStart(true)
  }

  const [permission, setPermission] = useState(false);
  const [stream, setStream] = useState(null);
  const mediaRecorder = useRef(null);
  const [recordingStatus, setRecordingStatus] = useState("inactive");
  const [audioChunks, setAudioChunks] = useState([]);
  const [audio, setAudio] = useState(null);
  const [finalAudio, setFinalAudio] = useState()
  const [myTimer, setMyTimer] = useState(0);
  const intervalRef = useRef(null);

  const cancelAudio = () => {
    setStream(null)
    setAudioChunks([])
    setAudio(null)
    setFinalAudio(null)
    setMyTimer(0)
    setRecordingStatus("inactive")
    setPermission(false)
  }


useEffect(()=>{
  if(myTimer >= 180){
    stopRecording()
  }
},[myTimer])
 
const startTimerRecordConfirmation = () => {
    if (intervalRef.current) return;
    intervalRef.current = setInterval(() => {
      setMyTimer((prev) => {
        const next = prev + 1;
        return next;
      });
    }, 1000);
  };
 
 
const stopTimerRecordConfirmation = () => {
  clearInterval(intervalRef.current);
  intervalRef.current = null;
};

// const getMicrophonePermission = async () => {
//     if ("MediaRecorder" in window) {
//         try {
//             const streamData = await navigator.mediaDevices.getUserMedia({
//                 audio: true,
//                 video: false,
//             });
//             setPermission(true);
//             setStream(streamData);
//         } catch (err) {
//             alert(err.message);
//         }
//     } else {
//         alert("The MediaRecorder API is not supported in your browser.");
//     }
// };

const mimeType = "audio/mpeg";

const startRecording = async () => {
  if ("MediaRecorder" in window) {
      try {
          // updateTimer()
          const streamData = await navigator.mediaDevices.getUserMedia({
              audio: true,
              video: false,
          });
          startTimerRecordConfirmation()
          setPermission(true);
          setStream(streamData);
          const media = new MediaRecorder(streamData, { type: mimeType });
          // console.log(media, stream)
          //set the MediaRecorder instance to the mediaRecorder ref
          mediaRecorder.current = media;
          //invokes the start method to start the recording process
          mediaRecorder.current.start();
          let localAudioChunks = [];
          mediaRecorder.current.ondataavailable = (event) => {
            if (typeof event.data === "undefined") return;
            if (event.data.size === 0) return;
            localAudioChunks.push(event.data);
            //  console.log(event.data)
          };
          setAudioChunks(localAudioChunks);
      } catch (err) {
          alert(err.message);
      }
  } else {
      alert("The MediaRecorder API is not supported in your browser.");
  }
    // setRecordingStatus("recording");
    //create new Media recorder instance using the stream
    // const media = new MediaRecorder(stream, { type: mimeType });
    // // console.log(media, stream)
    // //set the MediaRecorder instance to the mediaRecorder ref
    // mediaRecorder.current = media;
    // //invokes the start method to start the recording process
    // mediaRecorder.current.start();
    // let localAudioChunks = [];
    // mediaRecorder.current.ondataavailable = (event) => {
    //    if (typeof event.data === "undefined") return;
    //    if (event.data.size === 0) return;
    //    localAudioChunks.push(event.data);
    //   //  console.log(event.data)
    // };
    // setAudioChunks(localAudioChunks);
};

const stopRecording = () => {
  setRecordingStatus("inactive");
  // stopTimer();
  stopTimerRecordConfirmation()
  //stops the recording instance
  mediaRecorder.current.stop();
  mediaRecorder.current.onstop = () => {
    //creates a blob file from the audiochunks data
      const audioBlob = new Blob(audioChunks, { type: mimeType });
    //  const audioBlob = new Blob(audioChunks, { type: 'audio/mpeg' });

    const audioFile = new File([audioBlob], `record.mp3`, {
      type: "audio/mpeg"
    });

    //creates a playable URL from the blob file.
      const audioUrl = URL.createObjectURL(audioBlob);
      setFinalAudio(audioFile)
      setAudio(audioUrl);
    //  setAudioChunks([]);
    //  if(audioUrl){
    //   setUploadPhotoChat(audio);
    //  }
  };
};


  return (
    <div>
      <div className="container-fluid leases-single-div">
        
        {
          !listUserLoader 

          ?

          listUser.length !== 0 ? (
            <div className="row">
              <div className="col-12 px-0">
                {/* <div className={`${isShowChat ? "left-chat-mobile-container-show" : "left-chat-mobile-container"}`}>
                  <div className={`${isShowChat ? "left-chat-mobile-show" : "left-chat-mobile"}`}>
                    {listUser && listUser.map((list, index) => (
                        list.name &&
                          <div key={index} className="chat-msg-left-div"
                          onClick={()=>{
                            setChatOptionsHidden(true)
                            onClickChat(list)
                          }}
                          >
                          <div className="chatlist-img">
                            {
                                list.chat_count !== 0
                                &&
                            <div className="chat-counter">
                                <p>
                                {
                                  list.chat_count !== 0
                                  &&
                                  list.chat_count
                                }
                                {
                                list.chat_count > 99
                                 &&
                                 "99"
                                }
                              </p>
                            </div>
                            } 
                            {
                              list.is_online
                              &&
                                <div className="online-status">
                                  
                                </div>
                            }
                            <img src={list.avatar ? list.avatar : "../assets/images/profpic.svg"} />
                            
                          </div>
                          <div className="chatlist">
                            <p className="fs14 fw700 cblack mb-2 d-flex justify-content-between">
                              {list.name}
                              <span className={`fs12 fw400 cwhite ${list.chat_count ? "new-message-container" : "cgray"}`}>
                              {
                                list.chat_count > 0 ?
                                "New Message"
                                :
                                list.time
                              }
                              </span>
                            </p>
  
                            <p style={{maxWidth: '200px'}} className="fs14 cblack mb-0 pe-5 position-relative font-italic text-truncate">
                              {
                              list?.last_message === "" ?
                              <span className="fw400 cgray">Sent a file</span>
                              :
                              <span className="fw400 cgray">{list.last_message.replace("https://admin.renter.net/storage/", "")}</span>
                              }
                            </p>
                          </div>
                        </div>
                    ))}
                  </div>
                  <div className="chat-show-toggle" onClick={onToggleChat}>
                    <svg className={`${isShowChat ? 'chat-arrow-transform-show' : 'chat-arrow-transform'}`} fill="#ffffff" height="15px" width="15px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 330" stroke="#ffffff">
                      <path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001 c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213 C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606 C255,161.018,253.42,157.202,250.606,154.389z"/> 
                    </svg>
                  </div>
                </div> */}
                  
                <div className="chat-wrapper-div">
                  <div className="left-chat">
                    {listUser && listUser.map((list, index) => {
                      let attachmentType = null;
                      let fileType = list.last_message.slice((list.last_message.lastIndexOf('.') - 1 >>> 0) + 2);
                      if (imageFiles.includes(fileType)) {
                        attachmentType = 'image'
                      }
                      else if(audioFiles.includes(fileType)){
                        attachmentType = 'audio'
                      }
                      else if(list.last_message.includes("https://admin.renter.net"))
                      {
                        attachmentType = 'file'
                      }

                      return(
                        list.name &&
                          <div key={index} className="chat-msg-left-div"
                          onClick={()=>{
                            setChatOptionsHidden(true)
                            onClickChat(list)
                          }}
                          >
                          <div className="chatlist-img">
                            {
                                list.chat_count !== 0
                                &&
                            <div className="chat-counter">
                                <p>
                                {
                                  list.chat_count !== 0
                                  &&
                                  list.chat_count
                                }
                                {
                                list.chat_count > 99
                                 &&
                                 "99"
                                }
                              </p>
                            </div>
                            } 
                            {
                              list.is_online
                              &&
                                <div className="online-status">
                                  
                                </div>
                            }
                            <img src={list.avatar ? list.avatar : "../assets/images/profpic.svg"} />
                            
                          </div>
                          <div className="chatlist">
                            <p className="fs14 fw700 cblack mb-2 d-flex justify-content-between">
                              {list.name}
                              <span className={`fs12 fw400 cwhite ${list.chat_count ? "new-message-container" : "cgray"}`}>
                              {
                                list.chat_count > 0 ?
                                "New Message"
                                :
                                list.time
                              }
                              </span>
                            </p>
  
                            <p style={{maxWidth: '200px'}} className="fs14 cgray mb-0 pe-5 position-relative font-italic text-truncate">
                              {
                              attachmentType === "file" ?
                              <span className="fw400">Sent a file</span>
                              : attachmentType === "image"
                              ?
                              <span className="fw400">Sent an image</span>
                              : attachmentType === "audio"
                              ?
                              <span className="fw400">Sent an audio</span>
                              :
                              // <span className="fw400 cgray">{list.last_message.replace("https://admin.renter.net/storage/", "")}</span>
                              <span className="fw400">{list.last_message.replace("https://admin.renter.net/storage/", "")}</span>
                              }
                            </p>
                          </div>
                        </div>
                    )})}
  
                  </div>
                  <div className={`right-chat 
                    ${!chosenChat && "border-0"}
                    `}
                    >
                    {chosenChat ? 
                    (
                    <>
                      <div className="right-top">
                        <p className="mb-0 fw700 cblack fs18">{chosenChat && chosenChat.name}</p>
                        <div onClick={()=>{
                          setChatListModal(true)
                          // getChatListInfo();
                          }}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11 14H10V10H9M10 6H10.01M19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z" stroke="#1036CE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        </div>
                      </div>
                      <div className="msg-content-div">
                        <div id="bottomRef" ref={bottomRef}></div>
                        {chatList ? chatList.map((cl, index) => {
                          let attachmentType = null;
                          let fileType = cl.attachment.slice((cl.attachment.lastIndexOf('.') - 1 >>> 0) + 2);
                          if (imageFiles.includes(fileType)) {
                            attachmentType = 'image'
                          }
                          else if(audioFiles.includes(fileType)){
                            attachmentType = 'audio'
                          }
                          else 
                          {
                            attachmentType = 'file'
                          }
  
                          if(cl.sender_id === me.id) {
                            return (
                            <>
                              <div key={index} className="sender-div">
                                {/* <div> */}
                                  {cl.attachment !== "" &&  attachmentType === "image" ? (
                                    <div className="chat-img" onClick={()=>onViewPhoto(cl.attachment)}>
                                      <img src={cl.attachment} className="imgenclose" />
                                    </div>
                                  )
                                  :
                                   cl.attachment !== "" &&  attachmentType === "audio" ?
                                   <AudioFile 
                                   index={index} audio={cl}/>
                                  :
                                  cl.attachment !== "" &&  attachmentType === "file"
                                  ?
                                  <div key={index}>
                                    <div className="sender-msg-div">
                                      {/* <div className="sender-msg-div-content">
                                        {cl.message}
                                      </div> */}
  
                                      <ItemChat
                                      usertype={"sender"}
                                      // message={cl.message}
                                      attachment={cl.attachment}
                                      />
                                    </div>
                                  </div>
                                  : 
                                  (
                                    <div className="sender-msg-div" key={index}>
                                      {/* <div className="sender-msg-div-content">
                                        {cl.message}
                                      </div> */}
  
                                      <ItemChat
                                      usertype={"sender"}
                                      message={cl.message}
                                      />
                                    </div>
                                  )}
                                  
                                  <span className="fs12 cgray w-100 d-block text-end mt-1">{cl.time} {cl.date}</span>
                                {/* </div> */}
                              </div>
  
                              <div className="mt-3">
                                
                              </div>
                            </>
                            )
                          }
                          else {
                            return (
                            
                            <>
                              <div key={index} className="receiver-div">
                                <div>
                                  {cl.attachment !== "" &&  attachmentType === "image" ? (
                                    <div className="chat-img" onClick={()=>onViewPhoto(cl.attachment)}>
                                      <img src={cl.attachment} className="imgenclose" />
                                    </div>
                                  ) 
                                  :
                                   cl.attachment !== "" &&  attachmentType === "audio" ?
                                  <AudioFile 
                                   index={index} audio={cl}/>
                                  :
                                  cl.attachment !== "" &&  attachmentType === "file"
                                  ?
                                  <div>
                                    <div className="receiver-msg-div">
                                      {/* <div className="sender-msg-div-content">
                                        {cl.message}
                                      </div> */}
  
                                      <ItemChat
                                      usertype={"receiver"}
                                      // message={cl.message}
                                      attachment={cl.attachment}
                                      />
                                    </div>
                                  </div>
                                  : 
                                  (
                                    <div className="receiver-msg-div">
                                      <ItemChat
                                      usertype={"receiver"}
                                      message={cl.message}
                                      />
                                      {/* <div className="receiver-msg-div-content">
                                      {cl.message}
                                      </div> */}
                                    </div>
                                  )}
                                  
                                  <span className="fs12 cgray w-100 d-block mt-1">{cl.time} {cl.date}</span>
                                </div>
                              </div>
  
                              <div className="mt-3"></div>
                            </>
                            )
                          }
                        
                        })
                        :
                        <div className="loader my-5"></div>
                        }
                      </div>
  
  
                      <div className="right-bottom">
                        <div className="chat-input-div">
                          {permission ? 
                            <div className="form-control">
                              {permission && !audio ? (
                                <div className="play-recording-container">
                                  <div className="play-recording-button" onClick={stopRecording}>
                                    {/* <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
                                      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
                                      <g id="SVGRepo_iconCarrier"> <path d="M3 10L3 14M7.5 6L7.5 18M12 3V21M16.5 6V18M21 10V14" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/> </g>
                                    </svg> */}
                                      <svg fill="#ffffff" style={{padding: '5px'}} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 365 365"  width="30px" height="30px" stroke="#ffffff">

                                      <g id="SVGRepo_bgCarrier" strokeWidth="0"/>

                                      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>

                                      <g id="SVGRepo_iconCarrier"> <rect width="365" height="365"/> </g>

                                      </svg>
                                  </div>
                                  <div className="recording-time">
                                    <p>Recording...</p>
                                    <p>{`${('0'+Math.floor((myTimer % 3600) / 60)).slice(-2)}:${('0'+(myTimer % 60)).slice(-2)}`}</p>
                                  </div>
                                </div>
                                
                                ) : null}
                                {/* {recordingStatus === "recording" ? (
                                <div onClick={stopRecording}>
                                    Stop Recording
                                </div>
                                ) : null} */}

                            {audio ? (
                              <div className="audio-container">
                                <audio src={audio} controls></audio>
                                <div className="audio-cancel new-chat-features-div-tilt"
                                onClick={cancelAudio}
                                >
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M6 0.75V11.25M0.75 6H11.25" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                </div>
                              </div>
                            ) : null}
                            </div>
                            :
                            <input type="text" className="form-control" placeholder={intl.formatMessage({
                              id: 'typemessage.text',
                              defaultMessage: 'Type a message here...',
                              description: 'Type a message here...',
                            })} onKeyDown={handleKeyDown} onChange={(e) => setChatMsg(e.target.value)} value={chatMsg}
                            onClick={()=>{
                              setChatOptionsHidden(true)
                              }
                            }
                            />
                          }
                          {
                            !permission &&
                            <div onClick={()=>{
                              setChatOptionsHidden(!chatOptionsHidden)
                            }} className={`new-chat-features-div ${!chatOptionsHidden && "new-chat-features-div-tilt"}`}>
                              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 0.75V11.25M0.75 6H11.25" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                            </div>
                          }
                          
                          
                          
                          <div className={`${chatOptionsHidden ? "new-chat-features-div-toggle-hidden" :  "new-chat-features-div-toggle"}`}>
                            <img className={`chatIcon1 ${chatOptionsHidden && "iconsHidden"}`} src={chatCamera} 
                            onClick={()=>{
                              handleClickPhotoChat()
                              setChatOptionsHidden(!chatOptionsHidden)
                              }}/>
                            <input
                              type="file"
                              ref={hiddenFileInputPhotoChat}
                              onChange={handleChangePhotoChat}
                              accept="image/*"
                              capture="environment"
                              style={{display: 'none'}}
                            />
                            <img className={`chatIcon2 ${chatOptionsHidden && "iconsHidden"}`} src={chatFile}
                            onClick={()=>{
                              handleClickFileChat()
                              setChatOptionsHidden(!chatOptionsHidden)
                              }}
                            />
                            <input
                              type="file"
                              ref={hiddenFileInputFileChat}
                              onChange={handleChangeFileChat}
                              accept="image/*,.pdf,.doc,.docx,.txt"
                              style={{display: 'none'}}
                            />
                            <img className={`chatIcon3 ${chatOptionsHidden && "iconsHidden"}`} src={chatLocation}
                              onClick={()=>{
                                setMapModal(true)
                                setChatOptionsHidden(!chatOptionsHidden)
                              }}
                            />

                            <img className={`chatIcon4 ${chatOptionsHidden && "iconsHidden"}`} src={chatMicrophone}
                              onClick={()=>{
                                setChatOptionsHidden(!chatOptionsHidden)
                                  startRecording()
                              }}
                            />
                          </div>
                          
                          {/* <div className="chat-features-div">
                            <svg width="22" height="18" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={handleClickPhotoChat}>
                            <path fillRule="evenodd" clipRule="evenodd" d="M3.4002 2.7498C2.68411 2.7498 1.99735 3.03427 1.49101 3.54062C0.984659 4.04696 0.700195 4.73372 0.700195 5.44981V16.2498C0.700195 16.9659 0.984659 17.6526 1.49101 18.159C1.99735 18.6653 2.68411 18.9498 3.4002 18.9498H19.6002C20.3163 18.9498 21.003 18.6653 21.5094 18.159C22.0157 17.6526 22.3002 16.9659 22.3002 16.2498V5.44981C22.3002 4.73372 22.0157 4.04696 21.5094 3.54062C21.003 3.03427 20.3163 2.7498 19.6002 2.7498H17.4591C17.1011 2.74973 16.7578 2.60745 16.5046 2.35425L14.9913 0.840905C14.4851 0.334521 13.7984 0.0499576 13.0824 0.0498047H9.91799C9.20197 0.0499576 8.51533 0.334521 8.00909 0.840905L6.49575 2.35425C6.24263 2.60745 5.89931 2.74973 5.5413 2.7498H3.4002ZM11.5002 14.8998C12.032 14.8998 12.5587 14.7951 13.0501 14.5915C13.5414 14.388 13.9879 14.0897 14.364 13.7136C14.7401 13.3375 15.0384 12.891 15.2419 12.3997C15.4454 11.9083 15.5502 11.3817 15.5502 10.8498C15.5502 10.318 15.4454 9.79131 15.2419 9.29994C15.0384 8.80857 14.7401 8.3621 14.364 7.98602C13.9879 7.60995 13.5414 7.31162 13.0501 7.10809C12.5587 6.90456 12.032 6.79981 11.5002 6.79981C10.4261 6.79981 9.39594 7.2265 8.63641 7.98602C7.87689 8.74555 7.45019 9.77568 7.45019 10.8498C7.45019 11.9239 7.87689 12.9541 8.63641 13.7136C9.39594 14.4731 10.4261 14.8998 11.5002 14.8998Z" fill="#242424"/>
                            </svg>
                            <input
                              type="file"
                              ref={hiddenFileInputPhotoChat}
                              onChange={handleChangePhotoChat}
                              accept="image/*"
                              capture="environment"
                              style={{display: 'none'}}
                            />
                          </div>
                          <div className="chat-features-file-div">
                          <svg width="22" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={handleClickFileChat}>
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.7583 0.750097C16.4689 0.745795 17.1729 0.884287 17.8293 1.15715C18.4858 1.42999 19.0812 1.83157 19.5815 2.33783C20.0817 2.84407 20.4769 3.44493 20.7449 4.10519C21.0129 4.76543 21.1485 5.47241 21.1443 6.1853C21.1401 6.89819 20.9961 7.60349 20.7203 8.26045C20.4455 8.9151 20.045 9.50922 19.5412 10.0082L11.4822 18.1524L11.4754 18.159C10.8671 18.7555 10.0857 19.2189 9.15886 19.2373C8.21636 19.2561 7.39193 18.8102 6.72174 18.1381C5.91136 17.3254 5.68571 16.3423 5.80354 15.4664C5.91409 14.6445 6.31945 13.93 6.76671 13.4628L6.77354 13.4557L13.2747 6.87675C13.5658 6.58212 14.0407 6.5793 14.3353 6.87044L15.0466 7.57333C15.3413 7.86448 15.3441 8.33934 15.0529 8.63397L8.56738 15.1971C8.44404 15.3286 8.3128 15.5649 8.28123 15.7997C8.26687 15.9064 8.27488 15.9977 8.29992 16.0775C8.32376 16.1535 8.37372 16.2542 8.49207 16.3729C8.83879 16.7206 9.04311 16.7391 9.10912 16.7378C9.19021 16.7362 9.39502 16.6956 9.71903 16.3799L17.7739 8.23989L17.779 8.23486C18.0499 7.96733 18.2664 7.64724 18.4152 7.29271C18.5641 6.93816 18.6421 6.55669 18.6444 6.17052C18.6467 5.78436 18.5731 5.40188 18.4285 5.0454C18.2838 4.68895 18.071 4.36605 17.8032 4.09506C17.5355 3.8241 17.2181 3.61043 16.8698 3.46567C16.5216 3.32093 16.149 3.24778 15.7735 3.25005C15.398 3.25232 15.0263 3.32999 14.6798 3.47893C14.3334 3.62789 14.0186 3.84538 13.7542 4.11955L13.7489 4.12501L5.63139 12.3396L5.62494 12.346C5.19479 12.7689 4.8512 13.2749 4.61488 13.835C4.37855 14.3952 4.25443 14.9979 4.25012 15.608C4.24581 16.2181 4.3614 16.8226 4.58984 17.3864C4.7994 17.9036 5.31873 18.6255 5.78425 19.0965C6.26632 19.5844 7.0868 20.2047 7.57895 20.409C8.13199 20.6385 8.72402 20.7542 9.32077 20.7499C9.91752 20.7456 10.5078 20.6213 11.0575 20.3838C11.6072 20.1463 12.1057 19.8002 12.5237 19.3648L12.5299 19.3583L20.4623 11.331C20.7535 11.0363 21.2283 11.0335 21.523 11.3247L22.2343 12.0276C22.5289 12.3187 22.5317 12.7936 22.2406 13.0882L14.3206 21.103C13.6745 21.7742 12.9026 22.31 12.049 22.6788C11.1924 23.0488 10.2712 23.2431 9.33887 23.2498C8.40657 23.2566 7.48259 23.0757 6.62078 22.7181C5.69809 22.3352 4.60526 21.4602 4.00601 20.8538C3.39021 20.2306 2.64342 19.2398 2.27283 18.3252C1.9211 17.4572 1.74356 16.5276 1.75018 15.5903C1.7568 14.6531 1.94746 13.7261 2.31147 12.8633C2.67425 12.0034 3.20221 11.2237 3.86555 10.5699L11.9603 2.37823C12.4533 1.86865 13.0418 1.46191 13.6924 1.1822C14.3455 0.901404 15.0478 0.754399 15.7583 0.750097Z" fill="#000000"/>
                          </svg>
                            <input
                              type="file"
                              ref={hiddenFileInputFileChat}
                              onChange={handleChangeFileChat}
                              accept=".pdf,.doc,.docx,.txt"
                              style={{display: 'none'}}
                            />
                          </div> */}
                        </div>
                        <div>
                        {
                          !isSending
                          ?
                          <button className="btn btn-chat-send ms-2 me-2 sendMessageArror"
                          onClick={()=>{
                            setChatOptionsHidden(true)
                            onSendMessage()
                          }}
                          >
                            <svg width="25" height="25" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M32.6388 18.8779C32.9871 18.7034 33.28 18.4353 33.4847 18.1037C33.6894 17.7722 33.7979 17.3902 33.7979 17.0005C33.7979 16.6109 33.6894 16.2289 33.4847 15.8974C33.28 15.5658 32.9871 15.2977 32.6388 15.1231L3.23879 0.423146C2.87426 0.240748 2.46452 0.168384 2.05956 0.21488C1.6546 0.261377 1.27192 0.424725 0.958214 0.684998C0.644508 0.945271 0.41333 1.29122 0.292881 1.68063C0.172432 2.07005 0.167915 2.48611 0.279892 2.87805L3.28079 13.378C3.40631 13.8169 3.6714 14.2029 4.03592 14.4776C4.40044 14.7523 4.84454 14.9008 5.30099 14.9005H14.9001C15.457 14.9005 15.9912 15.1218 16.385 15.5156C16.7788 15.9094 17.0001 16.4436 17.0001 17.0005C17.0001 17.5575 16.7788 18.0916 16.385 18.4855C15.9912 18.8793 15.457 19.1005 14.9001 19.1005H5.30099C4.84454 19.1003 4.40044 19.2488 4.03592 19.5235C3.6714 19.7982 3.40631 20.1842 3.28079 20.623L0.28199 31.123C0.169792 31.5149 0.174038 31.9309 0.294201 32.3203C0.414368 32.7097 0.64526 33.0558 0.958725 33.3163C1.27219 33.5768 1.65467 33.7404 2.05953 33.7872C2.4644 33.8341 2.87414 33.7621 3.23879 33.58L32.6388 18.88V18.8779Z" fill="white"/>
                            </svg>
                          </button>
                        :
                        // 
                          <div className="loaderchat"></div>
                        }
                        </div>
                        
                        <div className="audio-controls">
                          {/* {!permission ? (
                              <button onClick={getMicrophonePermission} type="button">
                                  Get Microphone
                              </button>
                          ): null}
                          {permission ? (
                              <button type="button">
                                  Record
                              </button>
                          ): null} */}
                      </div>
                        
                      </div>
                      {/* <div>
                        <img style={{width: '200px'}} id="previewimg"></img>
                      </div> */}
                    </>
                    )
                    :
                    <>
                    </>
                  }
  
                  </div>
                </div>
  
              </div>
            </div>
          ) : (
            <div className="container main-wrap pt-5 mt-4 pb-5">
              <div className="row">
                <div className="col-12">
  
                  {/* <div className="search-chat-div">
                    <svg width="18" height="18" style={{position:"absolute", top:"9px", left:"16px"}} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M9 3.00017C7.4087 3.00017 5.88258 3.63231 4.75736 4.75753C3.63214 5.88275 3 7.40887 3 9.00017C3 10.5915 3.63214 12.1176 4.75736 13.2428C5.88258 14.368 7.4087 15.0002 9 15.0002C10.5913 15.0002 12.1174 14.368 13.2426 13.2428C14.3679 12.1176 15 10.5915 15 9.00017C15 7.40887 14.3679 5.88275 13.2426 4.75753C12.1174 3.63231 10.5913 3.00017 9 3.00017ZM1.70192e-07 9.00017C-0.000180585 7.58373 0.333964 6.18724 0.975257 4.92428C1.61655 3.66133 2.54688 2.56757 3.69059 1.73196C4.8343 0.896353 6.15909 0.342491 7.55722 0.115422C8.95534 -0.111646 10.3873 -0.0055103 11.7367 0.425198C13.0861 0.855907 14.3147 1.59903 15.3227 2.59412C16.3308 3.58921 17.0897 4.80817 17.5378 6.15187C17.9859 7.49557 18.1105 8.92606 17.9015 10.327C17.6925 11.7279 17.1558 13.0598 16.335 14.2142L23.5605 21.4397C23.8337 21.7226 23.9849 22.1015 23.9815 22.4948C23.9781 22.8881 23.8203 23.2643 23.5422 23.5424C23.2641 23.8205 22.8879 23.9783 22.4946 23.9817C22.1013 23.9851 21.7224 23.8339 21.4395 23.5607L14.2155 16.3367C12.869 17.2941 11.285 17.8624 9.63701 17.9794C7.98901 18.0963 6.34061 17.7573 4.87245 16.9996C3.40429 16.2419 2.17303 15.0947 1.31359 13.6837C0.45414 12.2727 -0.000321076 10.6523 1.70192e-07 9.00017Z" fill="#AAAAAA"/>
                    </svg>
                    <input type="text" className="form-control" placeholder="Search Messages" />
                  </div> */}
  
                  <div className="row mt-5 pt-5" style={{margin:"0 auto", maxWidth:"550px", width:"100%"}}>
                    <div className="col-12">
                      <div className="text-center">
                        <img src="assets/images/no-lease-img.png" className="img-fluid pt-5 mb-4" />
                        <p className="fs30 fw700 cgray">
                          <FormattedMessage 
                            id="youhavenochats.text"
                            defaultMessage="You have no active chats"
                            description="You have no active chats"
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          )

          :
          <div className="loader mb-4"></div>
        }
        
        
      </div>

      <Modal className="modalMapView" show={mapModal}
      onEscapeKeyDown={handleCloseModalMap}
      onHide={handleCloseModalMap}
      centered
      >
        <Modal.Body>
          <div className="map-modal-div">
            <MapContainer 
            setAddressLatLng={setAddressLatLng} addressLatLng={addressLatLng}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
        <Button variant="primary" onClick={()=>{
          setChatMsg(`https://www.google.com/maps?q=${addressLatLng?.latVal},${addressLatLng?.lngVal}`)
          handleCloseModalMap()
        }}>Save</Button>
        </Modal.Footer>
      </Modal>

      <Modal className="modalChatList" show={chatListModal}
      onEscapeKeyDown={handleCloseModalChatList}
      onHide={handleCloseModalChatList}
      centered
      >
        <Modal.Header style={{padding: "5px"}}>
          <div className="chat-room-header">
            Users Info
          </div>
        </Modal.Header>
        <Modal.Body>
          {
            chatRoomUserDetails &&
            <div>
              {
                chatRoomUserDetails?.map((data, index)=>{
                  return(
                    data.id !== me.id &&
                      <div key={index} className="chat-room-details">
                        <div className="phone-and-name">
                          <img style={{width: "25px"}} src={data.avatar ? data.avatar : defaultAvatar} />
                          <p>{data.name}</p>
                        </div>
                        
                        <div className="phone-and-name">
                        <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M16.1007 13.359L15.5719 12.8272H15.5719L16.1007 
                          13.359ZM16.5562 12.9062L17.085 13.438H17.085L16.5562 12.9062ZM18.9728 12.5894L18.6146 
                          13.2483L18.9728 12.5894ZM20.8833 13.628L20.5251 14.2869L20.8833 13.628ZM21.4217 16.883L21.9505 17.4148L21.4217 
                          16.883ZM20.0011 18.2954L19.4723 17.7636L20.0011 18.2954ZM18.6763 18.9651L18.7459 19.7119H18.7459L18.6763 18.9651ZM8.81536 
                          14.7266L9.34418 14.1947L8.81536 14.7266ZM4.00289 5.74561L3.2541 5.78816L3.2541 5.78816L4.00289 5.74561ZM10.4775 7.19738L11.0063 
                          7.72922H11.0063L10.4775 7.19738ZM10.6342 4.54348L11.2346 4.09401L10.6342 4.54348ZM9.37326 2.85908L8.77286 3.30855V3.30855L9.37326 
                          2.85908ZM6.26145 2.57483L6.79027 3.10667H6.79027L6.26145 2.57483ZM4.69185 4.13552L4.16303 3.60368H4.16303L4.69185 
                          4.13552ZM12.0631 11.4972L12.5919 10.9654L12.0631 11.4972ZM16.6295 13.8909L17.085 13.438L16.0273 12.3743L15.5719 
                          12.8272L16.6295 13.8909ZM18.6146 13.2483L20.5251 14.2869L21.2415 12.9691L19.331 11.9305L18.6146 13.2483ZM20.8929 
                          16.3511L19.4723 17.7636L20.5299 18.8273L21.9505 17.4148L20.8929 16.3511ZM18.6067 18.2184C17.1568 18.3535 13.4056 
                          18.2331 9.34418 14.1947L8.28654 15.2584C12.7186 19.6653 16.9369 19.8805 18.7459 19.7119L18.6067 18.2184ZM9.34418 
                          14.1947C5.4728 10.3453 4.83151 7.10765 4.75168 5.70305L3.2541 5.78816C3.35456 7.55599 4.14863 11.144 8.28654 15.2584L9.34418 
                          14.1947ZM10.7195 8.01441L11.0063 7.72922L9.9487 6.66555L9.66189 6.95073L10.7195 8.01441ZM11.2346 4.09401L9.97365 2.40961L8.77286 
                          3.30855L10.0338 4.99296L11.2346 4.09401ZM5.73263 2.04299L4.16303 3.60368L5.22067 4.66736L6.79027 3.10667L5.73263 2.04299ZM10.1907 
                          7.48257C9.66189 6.95073 9.66117 6.95144 9.66045 6.95216C9.66021 6.9524 9.65949 6.95313 9.659 6.95362C9.65802 6.95461 9.65702 
                          6.95561 9.65601 6.95664C9.65398 6.95871 9.65188 6.96086 9.64972 6.9631C9.64539 6.96759 9.64081 6.97245 9.63599 6.97769C9.62634 
                          6.98816 9.61575 7.00014 9.60441 7.01367C9.58174 7.04072 9.55605 7.07403 9.52905 7.11388C9.47492 7.19377 9.41594 7.2994 9.36589 
                          7.43224C9.26376 7.70329 9.20901 8.0606 9.27765 8.50305C9.41189 9.36833 10.0078 10.5113 11.5343 12.0291L12.5919 10.9654C11.1634 
                          9.54499 10.8231 8.68059 10.7599 8.27309C10.7298 8.07916 10.761 7.98371 10.7696 7.96111C10.7748 7.94713 10.7773 7.9457 10.7709 
                          7.95525C10.7677 7.95992 10.7624 7.96723 10.7541 7.97708C10.75 7.98201 10.7451 7.98759 10.7394 7.99381C10.7365 7.99692 10.7335 
                          8.00019 10.7301 8.00362C10.7285 8.00534 10.7268 8.00709 10.725 8.00889C10.7241 8.00979 10.7232 8.0107 10.7223 8.01162C10.7219 
                          8.01208 10.7212 8.01278 10.7209 8.01301C10.7202 8.01371 10.7195 8.01441 10.1907 7.48257ZM11.5343 12.0291C13.0613 13.5474 14.2096 
                          14.1383 15.0763 14.2713C15.5192 14.3392 15.8763 14.285 16.1472 14.1841C16.28 14.1346 16.3858 14.0763 16.4658 14.0227C16.5058 
                          13.9959 16.5392 13.9704 16.5663 13.9479C16.5799 13.9367 16.5919 13.9262 16.6024 13.9166C16.6077 13.9118 16.6126 13.9073 16.6171 
                          13.903C16.6194 13.9008 16.6215 13.8987 16.6236 13.8967C16.6246 13.8957 16.6256 13.8947 16.6266 13.8937C16.6271 13.8932 16.6279 
                          13.8925 16.6281 13.8923C16.6288 13.8916 16.6295 13.8909 16.1007 13.359C15.5719 12.8272 15.5726 12.8265 15.5733 12.8258C15.5735 
                          12.8256 15.5742 12.8249 15.5747 12.8244C15.5756 12.8235 15.5765 12.8226 15.5774 12.8217C15.5793 12.82 15.581 12.8183 15.5827 12.8166C15.5862 
                          12.8133 15.5895 12.8103 15.5926 12.8074C15.5988 12.8018 15.6044 12.7969 15.6094 12.7929C15.6192 12.7847 15.6265 12.7795 15.631 12.7764C15.6403 
                          12.7702 15.6384 12.773 15.6236 12.7785C15.5991 12.7876 15.501 12.8189 15.3038 12.7886C14.8905 12.7253 14.02 12.3853 12.5919 
                          10.9654L11.5343 12.0291ZM9.97365 2.40961C8.95434 1.04802 6.94996 0.83257 5.73263 2.04299L6.79027 3.10667C7.32195 2.578 8.26623 
                          2.63181 8.77286 3.30855L9.97365 2.40961ZM4.75168 5.70305C4.73201 5.35694 4.89075 4.9954 5.22067 4.66736L4.16303 3.60368C3.62571 
                          4.13795 3.20329 4.89425 3.2541 5.78816L4.75168 5.70305ZM19.4723 17.7636C19.1975 18.0369 18.9029 18.1908 18.6067 18.2184L18.7459 
                          19.7119C19.4805 19.6434 20.0824 19.2723 20.5299 18.8273L19.4723 17.7636ZM11.0063 7.72922C11.9908 6.7503 12.064 5.2019 11.2346 
                          4.09401L10.0338 4.99295C10.4373 5.53193 10.3773 6.23938 9.9487 6.66555L11.0063 7.72922ZM20.5251 14.2869C21.3429 14.7315 21.4703 
                          15.7769 20.8929 16.3511L21.9505 17.4148C23.2908 16.0821 22.8775 13.8584 21.2415 12.9691L20.5251 14.2869ZM17.085 13.438C17.469 
                          13.0562 18.0871 12.9616 18.6146 13.2483L19.331 11.9305C18.2474 11.3414 16.9026 11.5041 16.0273 12.3743L17.085 13.438Z" fill="#1036CE"/>
                        </svg>
                        <a href={`tel:${data.phone}`}>
                          {data.phone}
                        </a>
                        </div>
                      </div>
                    
                  )
                    
                })
              }
            </div>
            
          }
        </Modal.Body>
      </Modal>

      <Modal className="modalImageView" show={showModalStart} 
      onEscapeKeyDown={handleCloseModalStart}
      onHide={handleCloseModalStart}
      centered
      >
        <Modal.Body>
         {
          viewPhoto &&
          <div>
            <div className="close-modal" onClick={handleCloseModalStart}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="#ffffff" width="15" height="15" viewBox="0 0 24 24"><path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"/>
            </svg>
            </div>
            <img className="imgenclose" src={viewPhoto} />
          </div>
         }

        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ChatLease;
